// extracted by mini-css-extract-plugin
module.exports = {"acknowledgement":"application-intro_acknowledgement__35Ku4","title":"application-intro_title__3D2if"};